import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { CTASection } from "../components/Sections";
import { Reveal } from "../components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const { t } = useTranslation();
  const faqs = t("data.faqs", { returnObjects: true });
  return (
    <>
      <PageHero
        overline={t("faqPage.overline")}
        title={t("faqPage.title")}
        subtitle={t("faqPage.subtitle", { pronounced: t("common.pronounced") })}
        accent="signal"
        testId="faq-hero"
      />

      <section className="py-16">
        <div className="container-x max-w-3xl">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
              {faqs.map((item, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="surface px-6 border-b-0" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-start font-display font-medium text-base sm:text-lg hover:no-underline py-5">{item.q}</AccordionTrigger>
                  <AccordionContent className="text-white/60 leading-relaxed text-sm pb-5">{item.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <CTASection title={t("faqPage.ctaTitle")} subtitle={t("faqPage.ctaSub")} ctaLabel={t("common.getQuote")} ctaTo="/quote" testId="faq-cta" />
    </>
  );
}
